var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationEmptyStateGeneralEvaluation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #212529;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #7e0386;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #eef0f2;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-5",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.98,15.85L18.11,23.91c-3.5,.55-5.91,3.82-5.37,7.26l6.93,43.75c.54,3.44,3.85,5.8,7.35,5.24l50.87-8.06c3.5-.55,5.91-3.82,5.37-7.26l-6.93-43.75c-.54-3.44-3.85-5.8-7.35-5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.99,80.73c-1.44,0-2.85-.45-4.04-1.3-1.5-1.07-2.49-2.65-2.77-4.45L12.25,31.24c-.28-1.8,.16-3.6,1.26-5.08,1.1-1.48,2.7-2.46,4.52-2.74l50.87-8.06c1.82-.29,3.65,.14,5.15,1.21,1.5,1.07,2.49,2.65,2.77,4.45l6.93,43.75c.28,1.8-.16,3.6-1.26,5.08-1.1,1.48-2.7,2.46-4.52,2.74l-50.87,8.06c-.37,.06-.74,.09-1.11,.09ZM69.06,16.34L18.19,24.4c-1.56,.25-2.94,1.08-3.88,2.35-.94,1.27-1.32,2.8-1.08,4.33l6.93,43.75c.24,1.53,1.08,2.87,2.36,3.79,1.29,.92,2.85,1.29,4.41,1.04l50.87-8.06c1.56-.25,2.94-1.08,3.88-2.35,.94-1.27,1.32-2.8,1.08-4.33l-6.93-43.75c-.24-1.53-1.08-2.87-2.36-3.79-1.29-.92-2.85-1.29-4.41-1.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "59.4 55.8 49.03 48.35 52.81 43.23 58 46.96 66.51 35.46 71.73 39.18 59.4 55.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.51,56.5l-11.18-8.04,4.38-5.92,5.19,3.73,8.51-11.5,6.03,4.3-12.92,17.43Zm-9.78-8.26l9.56,6.87,11.73-15.82-4.4-3.14-8.51,11.5-5.19-3.73-3.19,4.31Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.58,
    y: 42.09,
    width: 17.23,
    height: 1,
    transform: "translate(-6.27 5.39) rotate(-8.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.85,
    y: 49.96,
    width: 17.23,
    height: 1,
    transform: "translate(-7.48 5.69) rotate(-8.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.08,
    y: 57.84,
    width: 17.23,
    height: 1,
    transform: "translate(-8.7 5.98) rotate(-8.98)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 96,
    height: 96
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateGeneralEvaluation);
export default __webpack_public_path__ + "static/media/illustration_empty-state-general-evaluation.447af882fd80a358afd3562fd3fde54f.svg";
export { ForwardRef as ReactComponent };